import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// تعريف الـ async thunk لطلب الـ API
export const fetchWorkDetails = createAsyncThunk(
  "workDetails/fetchWorkDetails",
  async ({id, lang}, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}work/details`,
        { id },
        {
          headers: {
            lang: lang,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// تعريف الـ slice
const WorkDetailsSlice = createSlice({
  name: "workDetails",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWorkDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchWorkDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default WorkDetailsSlice.reducer;
